import React, {
  KeyboardEventHandler,
  KeyboardEvent,
  useRef,
  useImperativeHandle,
} from 'react'
import { HiOutlineSearch } from 'react-icons/hi'
import { RiArrowDownSLine } from 'react-icons/ri'
import { useLocation } from 'react-router'

const AdvancedSearch = React.forwardRef<
  HTMLInputElement | null,
  IAdvancedSearch
>(({ onEnter, onPressFloating, placeholder }, ref: any) => {

  const location = useLocation()

  const onPressEnter = (e: KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter' && ref && ref.current) {
      onEnter(ref.current?.value)
    }
  }

  const onPressIcon = (): void => {
    onPressFloating && onPressFloating(true)
  }

  return (
    <div className={`${ onPressFloating ? 'w-64' : 'w-full'} h-9 flex bg-primary-100 dark:bg-primaryGray items-center justify-between p-2 rounded-lg`}>
      <HiOutlineSearch fontSize={25} className="text-primaryGray-400" />
      <input
        ref={ref}
        className={`${onPressFloating && !location.pathname.includes('/dashboard/inventario/servicios') ? 'w-44' : 'w-full'} bg-transparent border-transparent focus:ring-0 focus:border-transparent`}
        onKeyDown={onPressEnter}
        placeholder={placeholder}
      />
      {onPressFloating && !location.pathname.includes('/dashboard/inventario/servicios') &&  (
        <div onClick={onPressIcon} className="cursor-pointer">
          <RiArrowDownSLine fontSize={25} className="text-primaryGray-400" />
        </div>
      )}
    </div>
  )
})

interface IAdvancedSearch {
  onEnter: Function
  onPressFloating?: Function
  placeholder?: string
}

export default AdvancedSearch
